import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import BlockConfirmation from '../../components/block-confirmation';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const UnblockMemberModal = ({ closeModal, unblockMember, t }) =>
  <Modal onClose={closeModal}>
    <BlockConfirmation
      title={t('unblock-member-modal.unblock-user')}
      message={t('unblock-member-modal.are-you-sure')}
      confirmButton={t('unblock-member-modal.confirm')}
      onConfirm={unblockMember}
      onCancel={closeModal}
    />
  </Modal>;

UnblockMemberModal.propTypes = {
  userId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  unblockMember: PropTypes.func.isRequired,
  t: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      unblockMember: () => closeModal(ownProps.userId),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(UnblockMemberModal));



// WEBPACK FOOTER //
// ./app/containers/unblock-member-modal/unblock-member-modal.js